import Preact from 'preact';

var FormStructure = {
  fields: {
    headerLabel: {
      validations: []
    },
    firstName: {
      validations: [
        { type: 'required', message: 'This field is required. Please enter a value.'}
      ]
    },
    lastName: {
      validations: [
        { type: 'required', message: 'This field is required. Please enter a value.'}
      ]
    },
    email: {
      validations: [
        { type: 'required', message: 'This field is required. Please enter a value.'},
        { type: 'regex', pattern: '[a-z0-9!#$%&\'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&\'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?', message: 'Please provide a valid email.' }
      ]
    },
    telNumber: {
      validations: [
        { type: 'required', message: 'This field is required. Please enter a value.'},
        { type: 'regex', pattern: '[(]{0,1}[0-9]{3}[) ]{0,2}[-\s\.]{0,1}[0-9]{3}[-\s\.]{0,1}[0-9]{4}', message: 'Please provide a valid phone number.' }
      ]
    },
    addressline1: {
      validations: []
    },
    eventDate: {
      validations: [
        { type: 'dateinfuture', message: 'Event date must be in the future.' }
      ]
    },
    eventextra8: {
      validations: []
    },
    category: {
      validations: []
    },
    notes: {
      validations: []
    },
    plannedguestcount: {
      validations: []
    },  
    sitename: {
      validations: []
    },
    reference: {
      validations:[
        { type: 'required', message: 'This field is required. Please enter a value.'},
      ]
  }
  },
  layout: {
    rows: [
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'First Name*',
            mapping: 'firstName'
          },
          {
            type: 'text',
            size: 'Medium',
            label: 'Last Name*',
            mapping: 'lastName'
          }
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'Email*',
            mapping: 'email'
          },
          {
            type: 'text',
            size: 'Medium',
            label: 'Phone Number*',
            mapping: 'telNumber'
          }
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'Address',
            mapping: 'addressline1'
          }
        ]
      },
      {
        fields: [
          {
            type: 'multiple-choice',
            size: 'Medium',
            label: 'Type of Event',
            options: [
              { label: 'Social', value: 'Social'},
              { label: 'Corporate', value: 'Corporate'},                                          
              { label: 'Wedding', value: 'Wedding'}
            ],
            mapping: 'category'
          }
        ]
      },   
      {
        fields: [
          {
            type: 'date-picker',
            size: 'Medium',
            label: 'Date Desired',
            mapping: 'eventDate'
          },
          {
            type: 'multiple-choice',
            size: 'Medium',
            label: 'Is Your Date Flexible?',
            options: [
              { label: 'Yes', value: 'Yes'},
              { label: 'No', value: 'No'}                                        
            ],
            mapping: 'eventextra8'
          }
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'Estimated Guest Count',
            mapping: 'plannedguestcount'
          },
        ]
      },
      {
        fields: [
          {
              type: 'multiple-choice',
              size: 'Medium',
              label: 'Venue of Choice',
              options: [
                { label: 'Huguenot Loft', value: 'Huguenot Loft'},
                { label: 'Freeman Conference Room', value: 'Freeman Conference Room'},                                          
                { label: 'Ramsaur Studio', value: 'Ramsaur Studio'},
                { label: 'Genevieve’s', value: 'Genevieve’s'},
                { label: 'Concert Hall', value: 'Concert Hall'},                                          
                { label: 'Gunter Theatre', value: 'Gunter Theatre'},
                { label: 'TD Stage', value: 'TD Stage'}
              ],
              mapping: 'sitename'
            }
        ]
      },
      {
        fields: [
          {
              type: 'multiple-choice',
              size: 'Medium',
              label: 'How did you hear about us? *',
              options: [
                { label: 'Web', value: 'Web'},
                { label: 'Google Search', value: 'Google Search'},                                          
                { label: 'Facebook', value: 'Facebook'},
                { label: 'Instagram', value: 'Instagram'},
                { label: 'Other Social Media', value: 'Other Social Media'},
                { label: 'Peace Center', value: 'Peace Center'},
                { label: 'Attended Event', value: 'Attended Event'}, 
                { label: 'Referral', value: 'Referral'},                                         
                { label: 'Other', value: 'Other'},
              ],
              mapping: 'reference'
            }
        ]
      },
      {
        fields: [
          {
            type: 'text-area',
            size: 'Medium',
            label: 'About Your Event',
            mapping: 'notes'
          }
        ]
      },
      {
        fields: [
          {
            type: 'submit',
            size: 'XLarge',
            label: 'Submit'
          }
        ]
      }
    ]
  },
  info: {
    title: 'Peace Center Catering Contact Form',
    formId: '310',
    clientKey: 'A432538B-234F-4D5E-B8EC-342C5B19B70C',
    appKey: '23697F14-AA8C-4622-9F64-FC1A9FF20D0D',
    redirectUrl: 'https://specialevents.peacecenter.org/contact-us/thank-you',
    submissionText: 'Thank you! Your web inquiry has been successfully sent. We will contact you within one business day.',
    apiEndpoint: '//api-cec.catereasewebtools.com/inbound-inquiries'
  }
};


export default FormStructure;
